import ProtectedRoute from '../../wrappers/ProtectedRoutes'
import { AdminLayout } from '../../layouts/DashboardLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import AdminDashbaordPage from '../../pages/admin/AdminDashbaordPage'
import EntrepriseNav from '../features/EntrepriseNav'
import UserNav from '../features/UserNav'
import SubscriptionNav from '../features/SubscriptionNav'
import ModuleNav from '../features/ModuleNav'
import AnnonceNav from '../features/AnnonceNav'

export default function AdminProtectedNav() {
    return (
        <ProtectedRoute allowedRoles={["admin"]}>
            <AdminLayout>
                <Routes>
                    <Route path="/dashboard" element={<AdminDashbaordPage />} />
                    {/* Routes pour Support */}
                    <Route path="/entreprises/*" element={<EntrepriseNav />} />
                    <Route path="/users/*" element={<UserNav />} />
                    <Route path="/subscriptions/*" element={<SubscriptionNav />} />
                    <Route path="/modules/*" element={<ModuleNav />} />
                    <Route path="/annonces/*" element={<AnnonceNav />} />


                    {/* Redirection par défaut */}
                    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                </Routes>
            </AdminLayout>
        </ProtectedRoute>
    )
}